/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

export const BASE_URL_API = '/api';
export const BASE_URL_ADMINISTRES = `${BASE_URL_API}/administres`;
export const BASE_URL_ETATCIVIL = `${BASE_URL_ADMINISTRES}/etat-civil`;
